export default {"src":"/_next/static/media/wallets_created_logo.93ea73fd.svg","height":43,"width":82,"blurWidth":0,"blurHeight":0};